import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreThemes } from '../../../Types/StoreTypes';

const initialState: StoreThemes = {
    allThemes: {},
    selectedTheme: '',
    themeSwitcherState: '',
    currentThemeColor: '',
};

const themesSlice = createSlice({
    name: 'themes',
    initialState,
    reducers: {
        setAllThemes: (state, action: PayloadAction<StoreThemes['allThemes']>) => {
            state.allThemes = action.payload;
        },
        setSelectedTheme: (state, action: PayloadAction<StoreThemes['selectedTheme']>) => {
            state.selectedTheme = action.payload;
        },
        setSelectedThemeSwitcherState: (state, action: PayloadAction<StoreThemes['themeSwitcherState']>) => {
            state.themeSwitcherState = action.payload;
        },
        setCurrentThemeColor: (state, action: PayloadAction<StoreThemes['currentThemeColor']>) => {
            state.currentThemeColor = action.payload;
        },
    },
});

export const { setAllThemes, setSelectedTheme, setSelectedThemeSwitcherState, setCurrentThemeColor } =
    themesSlice.actions;

export default themesSlice.reducer;
